import { escapeHtml } from '../ui/dom.js';

export interface ToolkitItem {
  title?: string;
  Categories: string[];
  description?: string;
  examples?: string[];
}

function panelName(title: string): string {
  return `panel-${title.replaceAll(/\W+/g, '-')}`;
}

function renderExamples(examples: string[] | undefined, nested = false): string {
  if (!examples?.length) return '';
  if (nested) {
    return examples.map((example) => `<wa-card appearance="outlined"><p>${escapeHtml(example)}</p></wa-card>`).join('');
  }
  return examples.map((example) => `<p><strong>Example:</strong> ${escapeHtml(example)}</p>`).join('');
}

export function renderPackingView(items: ToolkitItem[], category: string): string {
  const filtered = items.filter((item) => item.Categories.includes(category));
  const cards = filtered
    .map(
      (item) => `<wa-card appearance="filled">
        <h5 slot="header">${escapeHtml(item.title ?? '')}</h5>
        <p><strong>Categories:</strong> ${escapeHtml(item.Categories.join(', '))}</p>
        <p>${escapeHtml(item.description ?? '')}</p>
        ${renderExamples(item.examples, true)}
      </wa-card>`
    )
    .join('');
  return `<h4>Packing Category</h4><div class="card-grid">${cards}</div>`;
}

export function renderDeviceView(items: ToolkitItem[]): string {
  const mobile = items
    .map(
      (item) => `<wa-details>
        <h5 slot="summary">${escapeHtml(item.title ?? '')}</h5>
        <p>${escapeHtml(item.description ?? '')}</p>
        ${renderExamples(item.examples)}
      </wa-details>`
    )
    .join('');

  const tabs = items
    .map((item) => `<wa-tab slot="nav" panel="${panelName(item.title ?? '')}">${escapeHtml(item.title ?? '')}</wa-tab>`)
    .join('');

  const panels = items
    .map(
      (item) => `<wa-tab-panel name="${panelName(item.title ?? '')}">
        <p>${escapeHtml(item.description ?? '')}</p>
        ${renderExamples(item.examples)}
      </wa-tab-panel>`
    )
    .join('');

  return `<h4>Device Type</h4>
    <wa-callout variant="info" open>Feel free to mix and match from these and other items to meet the needs of a specific role.</wa-callout>
    <div class="competency-mobile">${mobile}</div>
    <wa-tab-group class="competency-desktop">${tabs}${panels}</wa-tab-group>`;
}
